import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/home/Home.vue';
import FirstStep from '../views/firstStep/first-step.vue';
import ThirdStep from '../views/thirdStep/third-step.vue';
import SecondStep from '../views/secondStep/second-step.vue';
import resetKey from '../views/reset-key/reset-key.vue';
import recoveryPassword from '../views/recovery-password/recovery-password.vue';
import editAccount from '../views/editAccount/editAccount.vue';
import Finish from '../views/finish/finish.vue';
import previousOrders from '../views/previousOrders/previousOrders.vue';
import store from '../store';


Vue.use(VueRouter);

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/booking/date',
		name: 'firstStep',
		component: FirstStep,
		meta: {
			private: true,
		},
	},
	{
		path: '/booking/bin',
		name: 'secondStep',
		component: SecondStep,
		meta: {
			private: true,
		},
	},
	{
		path: '/booking/confirmed',
		name: 'thirdStep',
		component: ThirdStep,
		meta: {
			private: true,
		},
	},
	{
		path: '/booking/info',
		name: 'finish',
		component: Finish,
		meta: {
			private: true,
		},
	},
	{
		path: '/editAccount',
		name: 'editAccount',
		component: editAccount,
	},
	{
		path: '/previousOrders',
		name: 'previousOrders',
		component: previousOrders,
	},
	{
		path: '/reset',
		name: 'resetKey',
		component: resetKey,
	},
	{
		path: '/recovery',
		name: 'recoveryPassword',
		component: recoveryPassword,
	},
	{
		path :'*',
		meta: {
			error: true,
		},
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	if (to.meta.error) {
		store.commit("clearStore");
		next({
			name: 'Home',
		});
	}
	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
	next();
});

export default router;
